import manage from './manage'
import group from './group'
import member from './member'
import invite from './invite'
export default {
  namespaced: true,
  modules: {
    manage,
    group,
    member,
    invite
  }
}
